import { IconPresentationProps } from "@insite/mobius/Icon";
import * as React from "react";

const User: React.FC<IconPresentationProps> = props => {
    return (
        <svg
            focusable="false"
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="currentColor"
            fillRule="nonzero"
            stroke="none"
            role="img"
        >
            {props.title && <title>{props.title}</title>}
            <path d="M 0 0 L 0 24 L 24 24 L 24 0 L 0 0 z M 12 4 C 14.20938 4 16 5.7906186 16 8 C 16 10.209381 14.209381 12 12 12 C 9.7906198 12 8 10.209381 8 8 C 8 5.7906186 9.7906188 4 12 4 z M 12 5 C 10.346864 5 9 6.346863 9 8 C 9 9.653137 10.346863 11 12 11 C 13.653137 11 15 9.653137 15 8 C 15 6.346863 13.653137 5 12 5 z M 9.1992188 13 C 10.099212 13 10.528138 13.5 12 13.5 C 13.471863 13.5 13.903932 13 14.800781 13 C 17.11954 13 19 14.880463 19 17.199219 L 19 18.5 C 19 19.328124 18.328125 20 17.5 20 L 6.5 20 C 5.671875 20 5 19.328123 5 18.5 L 5 17.199219 C 5 14.880463 6.8804623 13 9.1992188 13 z M 9.1992188 14 C 7.4335939 14 6 15.433595 6 17.199219 L 6 18.5 C 6 18.774994 6.2250066 19 6.5 19 L 17.5 19 C 17.774996 19 18 18.774994 18 18.5 L 18 17.199219 C 18 15.433595 16.566407 14 14.800781 14 C 14.188295 14 13.575012 14.5 12 14.5 C 10.421874 14.5 9.8117072 14 9.1992188 14 z " />
        </svg>
    );
};

export default React.memo(User);
